import { createSelector, MemoizedSelector } from '@ngrx/store';
import { Price } from '@product/const';
import { StateUtils } from '@spartacus/core';
import { ProductState, StateWithProduct } from '../product-state';
import { getCustomProductState } from './feature.selector';

type PricesState = ProductState['prices'];

const getPricesEntityState: MemoizedSelector<StateWithProduct, PricesState> = createSelector(
  getCustomProductState,
  (state: ProductState) => state.prices,
);

export const getPricesState = (code: string): MemoizedSelector<StateWithProduct, StateUtils.LoaderState<Price[]>> =>
  createSelector(getPricesEntityState, (state) => StateUtils.entitySelector(state, code));

export const getPricesValue = (code: string): MemoizedSelector<StateWithProduct, Price[]> =>
  createSelector(getPricesEntityState, (state) => StateUtils.entityValueSelector(state, code));

export const getPricesLoading = (code: string): MemoizedSelector<StateWithProduct, boolean> =>
  createSelector(getPricesEntityState, (state) => StateUtils.entityLoadingSelector(state, code));

export const getPricesSuccess = (code: string): MemoizedSelector<StateWithProduct, boolean> =>
  createSelector(getPricesEntityState, (state) => StateUtils.entitySuccessSelector(state, code));

export const getPricesError = (code: string): MemoizedSelector<StateWithProduct, boolean> =>
  createSelector(getPricesEntityState, (state) => StateUtils.entityErrorSelector(state, code));
